import { useEffect, useState } from "react";
import { api } from "./api";

export const favoriteCustomEmoji = [
  "sparkling_heart",
  "loll",
  "yayayayayay",
  "skulk",
  "upvote",
  "yay",
  "this",
  "heavysob",
  "real",
  "pf",
  "thumbup-nobg",
  "mhm",
  "fear",
  "noooovanish",
  "sob-wx",
  "star",
  "agadance",
  "hii",
  "neocat_hug_haj_sad",
  "grr",
  "yesyes",
  "dead",
  "ms-thinking",
  "rac_pf",
  "sobbing",
  "thinking",
  "sad-pf",
  "dinowow",
  "sipp",
  "sad-cat-thumbs-up",
  "index_pointing_at_the_viewer",
  "thumbsup-dino",
  "skulley",
  "ms-shrug",
  "ms-smile-hearts",
  "ms-rolling-eyes",
  "ms-slight-frown",
  "ms-smile",
  "thinkies",
  "cwy",
  "discoduck",
  "glittering",
  "gleam",
  "uno-uwu",
  "cryign",
  "yay-mimi",
  "pweas",
  "vibesock",
  "bye",
  "pls",
  "oke",
  "dance_catgirl",
  "curious",
  "rayge",
  "ouno-question",
  "heidi-paws",
  "aww",
  "awww",
  "pwease-cute",
  "criblub",
  "i-need-sleep",
  "np",
  "macondo-source-code-zip",
  "happi",
  "yippeeyay",
  "pleaseduck",
  "wiggle",
  "woooo",
  "ultrafastparrot",
  "fire",
  "pepe-thumbsup",
  "wilted_flower",
  "sob",
  "3c",
  "sparkling_fart",
  "bangbang",
  "agahi",
  "sad_pepe",
  "salute",
  "beg",
] as const;

export const favoriteCustomEmojiSet = new Set<string>(favoriteCustomEmoji);

export function favoriteEmojiItems(catalog: Record<string, string>, query: string) {
  return favoriteCustomEmoji.flatMap((name) => {
    const url = catalog[name];
    return name.includes(query) && url && !url.startsWith("alias:") ? ([[name, url]] as const) : [];
  });
}

let emojiCatalogRequest: Promise<Record<string, string>> | undefined;

async function fetchEmojiCatalog(): Promise<Record<string, string>> {
  // Retry transient failures a couple times before giving up, so a blip in the
  // Slack/Cachet emoji fetch doesn't leave the picker empty.
  let lastError: unknown;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      return await api.emoji();
    } catch (error) {
      lastError = error;
      if (attempt < 2) await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)));
    }
  }
  throw lastError;
}

export function useEmojiCatalog() {
  const [catalog, setCatalog] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    let mounted = true;
    emojiCatalogRequest ??= fetchEmojiCatalog();
    emojiCatalogRequest
      .then((value) => {
        if (mounted) setCatalog(value);
      })
      .catch(() => {
        if (mounted) setError(true);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);
  return { catalog, loading, error };
}

/** Resolves `:name:` to an emoji image URL, ignoring aliases and unknowns. */
export function emojiUrlResolver(catalog: Record<string, string>) {
  return (name: string) => {
    const url = catalog[name];
    return url && !url.startsWith("alias:") && url.startsWith("http") ? url : null;
  };
}
